export const routes = {
  home: '/',
  login: '/login',
  agenda: '/agenda',
  config: '/config',
  new: '/new',
  informpassword: '/informpassword'
};
